import { BaseService } from "@kiddocare-platform/portal-common/base";

export class PlatformRegistryService extends BaseService {

  public async CheckDevice(params: {
    token: string,
    type: string,
    identifier: string
  }) {
    try {
      const response = await this.AxiosInstance.post(`pediatrician/registry/checkDevice`, params);
      return response.data;
    } catch (error: any) {
      this.log.error("CheckDevice", error.stack, JSON.stringify(error));
      throw error;
    }
  }


}